module.exports = __webpack_public_path__ + "img/text-img.8836c908.png";